module.exports = __webpack_public_path__ + "media/images/application/template/helifix-brochure-2b5258313893952bb3d6bad3b25284e8.png";